// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603271033/js/" + chunkId + "." + {"44":"f00aee65","225":"5e73995a","481":"e17721dc","486":"846875c2","770":"97f05be2"}[chunkId] + ".0.23418129016561573.chunk.js";
};